import React from 'react';
import DiagnosticsStore from './../stores/DiagnosticsStore';
import DiagnosticsConstants from './../constants/DiagnosticsConstants';
import DiagnosticsActions from './../actions/DiagnosticsActions';
import * as Inovx from '@shared';
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var InovxControls = Inovx.Shared.Controls;
declare var InovxLoader: any;

interface DiagnosticsFormProps {
    title: string;
}
interface DiagnosticsFormState {
    messageID: string;
    message: string;
    caption: string;
    date: string;
    level: string;
    source: string;
    sessionID: string;
    hostName: string;
    clientIP: string;
    userName: string;
    version: string;
    exceptionData: string;
    time: string;
    service: string;
    detailKeys: any[];
    detailValues: any[];
    description: string;
}
function getFormState(): DiagnosticsFormState {

    var diagnostic = DiagnosticsStore.getDiagnostic();

    var detailKeys  : string[] = [];
    var detailValues: string[] = [];

    if (diagnostic.Details) {
        for (var x = 0; x < diagnostic.Details.length; x++) {

            detailKeys.push((diagnostic.Details[x] as any).Key);
            detailValues.push((diagnostic.Details[x] as any).Value);
        }
    }
    var notApplicable = InovxLoader.t('Diagnostics:form.notApplicable');
    return {
        messageID: diagnostic.MessageId && diagnostic.MessageId.length > 0 ? diagnostic.MessageId : notApplicable,
        message: diagnostic.Message && diagnostic.Message.length > 0 ? diagnostic.Message : notApplicable,
        caption: diagnostic.Caption && diagnostic.Caption.length > 0 ? diagnostic.Caption : notApplicable,
        level: diagnostic.LogLevel && diagnostic.LogLevel.length > 0 ? diagnostic.LogLevel : notApplicable,
        source: diagnostic.Source && diagnostic.Source.length > 0 ? diagnostic.Source : notApplicable,
        sessionID: diagnostic.SessionId && diagnostic.SessionId.length > 0 ? diagnostic.SessionId : notApplicable,
        hostName: diagnostic.HostName && diagnostic.HostName.length > 0 ? diagnostic.HostName : notApplicable,
        clientIP: diagnostic.ClientIp && diagnostic.ClientIp.length > 0 ? diagnostic.ClientIp : notApplicable,
        userName: diagnostic.ClientUserName && diagnostic.ClientUserName.length > 0 ? diagnostic.ClientUserName : notApplicable,
        version: diagnostic.Version && diagnostic.Version.length > 0 ? diagnostic.Version : notApplicable,
        service: diagnostic.Service && diagnostic.Service.length > 0 ? diagnostic.Service : notApplicable,
        exceptionData: diagnostic.ExceptionData,
        detailKeys: detailKeys,
        detailValues: detailValues,
        description: diagnostic.Description,
        date: diagnostic.DateDisplay && diagnostic.DateDisplay.length > 0 ? diagnostic.DateDisplay : notApplicable,
        time: diagnostic.TimeDisplay && diagnostic.TimeDisplay.length > 0 ? diagnostic.TimeDisplay : notApplicable
    };

}

class DiagnosticsForm extends Inovx.Shared.ReactExt.BaseAppComponent<DiagnosticsFormProps, DiagnosticsFormState> {
    constructor(props: DiagnosticsFormProps, context: any) {
        super('Diagnostics', props, context);

        this._initialize = this._initialize.bind(this);

        this.state = getFormState();
    }

    protected _initialize() {
    }

    private _onSystemChange = () => {
        this.setState({
        } as any);
    }



    private _onCloseForm = () => {
        DiagnosticsActions.CloseDiagnosticInformation();
    }

    componentDidMount() {
        this.componentWillMountBase();
        SystemStore.addChangeListener(this._onSystemChange);
    }

    componentWillUnmount() {
        SystemStore.removeChangeListener(this._onSystemChange);
    }


    public render() {
        var diagnostic = this.state;

        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        return (
            <Inovx.Shared.Core.ReactLoader appReady={true} errorStatus={this._errorStatus}>

                <div className="panel panel-primary diagnostics-content diagnostics-form">
                    <div className="panel-heading">{this.props.title}</div>
                    <div className="panel-body fc-margin">
                        <InovxControls.GroupBox title="" class="gb-diagnostics">
                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-messageId" htmlFor="MessageID">{InovxLoader.t("Diagnostics:form.messageID")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-message-id" className="content-messageId">{diagnostic.messageID}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row-padding">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-caption" htmlFor="Message">{InovxLoader.t("Diagnostics:form.message")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-justify text-black">
                                    <span id="diagPopup-message" className="content-messageId">{diagnostic.message}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row-padding">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-caption" htmlFor="Caption">{InovxLoader.t("Diagnostics:form.detail")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-justify text-black">
                                    <span id="diagPopup-caption" className="content-messageId">{diagnostic.caption}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-level" htmlFor="Level">{InovxLoader.t("Diagnostics:form.level")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-justify text-black">
                                    <span id="diagPopup-level" className="content-messageId">{diagnostic.level}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-date" htmlFor="Date">{InovxLoader.t("Diagnostics:form.date")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-date" className="content-messageId">{diagnostic.date}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-date" htmlFor="Time">{InovxLoader.t("Diagnostics:form.time")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-time" className="content-messageId">{diagnostic.time}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="Source">{InovxLoader.t("Diagnostics:form.source")}</label>
                                    </div>
                                </div>

                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-source" className="content-messageId">{diagnostic.source}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row-padding">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="service">{InovxLoader.t("Diagnostics:form.service")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-service" className="content-messageId">{diagnostic.service}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.sessionID")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-session-id" className="content-messageId">{diagnostic.sessionID}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.hostName")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-host-name" className="content-messageId">{diagnostic.hostName}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.clientIP")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-client-ip" className="content-messageId">{diagnostic.clientIP}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.userName")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-user-name" className="content-messageId">{diagnostic.userName}</span>
                                </div>
                            </div>

                            <div className="row diagnostics-form-row">
                                <div className="col-sm-2 col-bold">
                                    <div className="form-field">
                                        <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.version")}</label>
                                    </div>
                                </div>
                                <div className="col-sm-10 word-wrap text-black">
                                    <span id="diagPopup-version" className="content-messageId">{diagnostic.version}</span>
                                </div>
                            </div>


                            <InovxControls.If condition={diagnostic.description && diagnostic.description.length > 0}>
                                <div className="row diagnostics-form-row-top-padding">
                                    <div className="col-sm-2 col-bold">
                                        <div className="form-field">
                                            <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.description")}</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-10 word-wrap text-black">
                                        <span className="content-messageId">{diagnostic.description}</span>
                                    </div>
                                </div>
                            </InovxControls.If>

                            <InovxControls.If condition={diagnostic.detailKeys.length > 0}>
                                <div className="row diagnostics-form-row-top-padding">
                                    <div className="col-sm-2 col-bold">
                                        <div className="form-field">
                                            <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.details")}</label>
                                        </div>
                                    </div>
                                </div>

                                {diagnostic.detailKeys.map((row: any, indx: number) => {
                                    return <div key={indx} className="row diagnostics-form-row">
                                        <div className="col-sm-3 word-wrap text-black">
                                            <span className="content-messageId">{diagnostic.detailKeys[indx]}</span>
                                        </div>
                                        <div className="col-sm-9 word-wrap text-black">
                                            <span className="content-messageId">{diagnostic.detailValues[indx]}</span>
                                        </div>
                                    </div>
                                })}
                            </InovxControls.If>

                            <InovxControls.If condition={diagnostic.exceptionData && diagnostic.exceptionData.length > 0}>
                                <div className="row diagnostics-form-row-top-padding">
                                    <div className="col-sm-3 col-bold">
                                        <div className="form-field">
                                            <label className="label-source" htmlFor="Date">{InovxLoader.t("Diagnostics:form.exceptionData")}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row diagnostics-form-row">
                                    <div className="col-sm-12 word-wrap text-left text-black preserve-whitespace">
                                        <span className="content-messageId">{diagnostic.exceptionData}</span>
                                    </div>
                                </div>
                            </InovxControls.If>
                        </InovxControls.GroupBox>

                        <div className="btn-bar-b-sm">
                            <button type="button" className="btn btn-primary" onClick={this._onCloseForm}>{InovxLoader.t("Diagnostics:form.Ok")}</button>
                        </div>
                    </div>
                    </div>
            </Inovx.Shared.Core.ReactLoader>
        );
    }
}

export default DiagnosticsForm;
